var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrColoredIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4514_374)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9362 22.7428C29.7357 22.2415 29.2345 21.9408 28.633 22.1413L26.0266 23.0435C23.3199 23.9457 20.3125 23.645 17.8064 22.442L18.0069 22.2415C19.7111 20.5374 19.7111 17.7305 18.0069 16.0263L10.4884 8.50781C9.18521 7.00412 6.7793 7.00412 5.37585 8.40756L0.965017 12.8184C0.664278 13.1191 0.463785 13.5201 0.463785 14.0213C0.463785 14.5226 0.664278 14.9236 0.965017 15.2243C1.56649 15.8258 2.46871 15.926 3.07019 15.4248L7.98225 12.2169L10.7891 15.0238L8.18275 17.6302C6.57881 17.53 4.87462 17.7305 3.27068 18.2317L0.664278 19.1339C0.163047 19.3344 -0.137692 19.8356 0.0628005 20.4371C0.263293 20.9383 0.764524 21.2391 1.366 21.0386L3.9724 20.1364C7.58127 18.9334 11.5911 19.7354 14.398 22.3418C16.7037 24.447 19.7111 25.5497 22.8187 25.5497C24.1219 25.5497 25.5253 25.3492 26.8285 24.9482L29.435 24.046C29.8359 23.8455 30.1367 23.244 29.9362 22.7428Z",
    fill: "#7382D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0201 15.0246C24.827 15.0246 27.0324 12.8192 27.0324 10.0123C27.0324 7.20542 24.827 5 22.0201 5C19.2132 5 17.0078 7.20542 17.0078 10.0123C17.0078 12.8192 19.2132 15.0246 22.0201 15.0246Z",
    fill: "#7382D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4514_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrColoredIconTwo);
export default __webpack_public_path__ + "static/media/ahr-colored-icon-two.bc7a680f7fd1ab4510a797ca4396c555.svg";
export { ForwardRef as ReactComponent };